import { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import Layout from './DashboardLayout';
import { ArchivedProject, ProjectSearch } from '../components/project';

class Project extends Component {
  pageHeading = {
    preTitle: 'Projects',
    title: 'Archived Projects',
  };

  componentDidMount() {}

  render() {
    return (
      <Layout pageHeading={this.pageHeading}>
        <Row className="mb-4">
          <Col md="6" lg="3">
            <ProjectSearch statusType="close" />
          </Col>
        </Row>
        <Row>
          <ArchivedProject />
        </Row>
      </Layout>
    );
  }
}

export default Project;
